import { Badge } from '@/components/ui/badge';
import { AlertTriangle, AlertCircle, ShieldCheck } from 'lucide-react';

export const LIVELLO_STILE = {
  rosso: { badge: 'bg-red-100 text-red-700 border-red-200', card: 'border-red-200 bg-red-50/40', dot: 'bg-red-500', text: 'text-red-700', label: 'Critico' },
  giallo: { badge: 'bg-amber-100 text-amber-700 border-amber-200', card: 'border-amber-200 bg-amber-50/40', dot: 'bg-amber-500', text: 'text-amber-700', label: 'Attenzione' },
  verde: { badge: 'bg-emerald-100 text-emerald-700 border-emerald-200', card: 'border-emerald-200 bg-emerald-50/40', dot: 'bg-emerald-500', text: 'text-emerald-700', label: 'Regolare' },
};

export const LivelloBadge = ({ livello, testo, testid }) => {
  const s = LIVELLO_STILE[livello] || LIVELLO_STILE.verde;
  const Icon = livello === 'rosso' ? AlertTriangle : livello === 'giallo' ? AlertCircle : ShieldCheck;
  return (
    <Badge className={`text-[10px] gap-1 border ${s.badge}`} data-testid={testid}>
      <Icon className="w-3 h-3" />{testo || s.label}
    </Badge>
  );
};

export const AlertRow = ({ a, testid }) => {
  const s = LIVELLO_STILE[a.livello] || LIVELLO_STILE.verde;
  return (
    <div className={`rounded-lg border p-3 ${s.card}`} data-testid={testid}>
      <div className="flex items-start gap-2">
        <span className={`w-2 h-2 rounded-full mt-1.5 shrink-0 ${s.dot}`} />
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <p className={`text-sm font-semibold ${s.text}`}>{a.titolo}</p>
            <Badge variant="outline" className="text-[9px] uppercase tracking-wide">{a.categoria}</Badge>
          </div>
          <p className="text-xs text-slate-600 mt-1 break-words">{a.dettaglio}</p>
          {a.azione && <p className="text-[11px] text-slate-500 mt-1 italic">{a.azione}</p>}
        </div>
      </div>
    </div>
  );
};
